/**
 *  UPDATE on IN_LINE VERSION
 *  gaelh@
 *
 *  In order to make puzzle party compatible with the INLINE option,
 *  I had to make important change, specially concerning paperjs interactive event
 *  Beside deactivating the WHEEL event (desktop) and the PINCH event (mobile),
 *  I implemented a double finger drag (mobile) and add back the zoom icons (mobile).
 *
 *  A Big issue has been the handling of the single finger drag, available in the regular version.
 *  As events propagation has been stopped by PAPERJS, it wasn't possible to handle both
 *  dragging of the piece, dragging of the stage and scrolling with the same event.
 *
 *  I've removed the preventDefault and stop propagation from the minified libraire of paperjs
 *  to handle the event behaviour. The original file is still available in third party,
 *  but the changed version is now static/third_party/paper-9.25-full.min.custom.js.
 *
 *  I've also forced the default touch-action style generated by PAPERJS, because it was
 *  blocking the touch events (line 1258)
 *
 *  Most of the conditions to handle INLINE are checking this.IS_INLINE parameter.
 *  Mouse function onMouseDown onMouseDrag are now handling event propagation.
 *
 */

import Gallery from "../js/Gallery.js";
import Puzzle from "./Puzzle.js";
import AxL from "../js/axl.js";
import Tooltips from "./Tooltips.js";
import SavingTip from "./SavingTip.js";
import TranslationManager from "./TranslationManager.js";
import { MDCLinearProgress } from "@material/linear-progress";
// import * as closure from "./node_modules/google-closure-library/closure";
import Firebase from "./Firebase.js";
export default class App {
  constructor() {
    this.START_PUZZLE_GAME();
  }
  async START_PUZZLE_GAME() {
    console.log(
      "started",
      window.devicePixelRatio,
      window.navigator.maxTouchPoints
    );
    this.isMobile = false;
    // device detection
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      this.isMobile = true;
    }
    console.log("this is a mobile : ", this.isMobile);

    let host = location.hostname;
    //detect if we are outside STELLA
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // LANG
    this.LANG = urlParams.get("lang") || "en";
    // update on 2024-06-05
    // switch to locale parameter
    // this.LANG = urlParams.get("locale") || "en";
    this.languages = [
      "en",
      "es-419",
      "es",
      "fr",
      "hi",
      "it",
      "ja",
      "pt-BR",
      "pt-PT",
      "pt",
      "zh-CN",
      "zh-TW",
      "zh-HK",
      "zh",
      "pl",
      "in",
      "ko",
      "ms",
      "th",
      "vi",
      "cs",
    ];
    let isLangSupported = this.languages.includes(this.LANG);
    if (!isLangSupported) {
      this.LANG = "en";
    }
    // this.LANG = this.LANG == "es-419" ? "es" : this.LANG;
    // this.LANG = this.LANG == "pt-PT" ? "pt-BR" : this.LANG;
    /*
		TRANSLATION HERE
	*/
    // this.initTranslator();
    this.translator = new TranslationManager(this.LANG);
    console.log("wait for data init");
    let translationReady = await this.translator.init();
    this.translator.setDefault();
    this.customGallery = urlParams.get("gallery");
    // INLINE OPTION
    this.IS_INLINE = urlParams.has("inline");

    if (host == "localhost__" || urlParams.get("optout")) {
      this.init();
    } else {
      this.axl = new AxL();
      this.initAxL();
    }

    this.reqCounter = 0;
    // CALL LIMITATION ( to avoid FIREBASE OVERLOAD )
    this.AUTHORIZE_CALL = true;
    // GRACEFUL OPTION
    this.GRACEFUL = urlParams.has("graceful");

    // Number of USERS max.
    // MUST BE BIGGER THAN 1
    this.USER_LIMIT = 100;
    this.GAME_STATE = "ready";
  }

  async initTranslator() {
    this.translator = new TranslationManager(this.LANG);
    console.log("wait for data init");
    let translationReady = await this.translator.init();
    this.translator.setDefault();
  }
  async initAxL() {
    // this.axl.registerMessageCallback(AxL.HostToChild.RESUME, (payload) => {
    // 	if (!this.puzzle) this.init();
    // });
    // const initialData = await this.axl.handshake();
    // this.game_id = initialData.puzzleId;
    // console.log('axl initiated', this.game_id);

    // if (this.game_id) {
    // 	this.database = firebase.database();
    // 	this.game_id = await this.verifyGame();
    // 	// --> ANALYTICS
    // 	if (this.axl && this.game_id) {
    // 		this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    // 			action: 'start_game',
    // 			label: 'remote',
    // 			value: this.game_id,
    // 			nonInteraction: false
    // 		});
    // 	}
    // }
    //  else {
    // 	this.init();
    // }

    //------------
    const gotFirstResume = new Promise((resolve) => {
      this.axl.registerMessageCallback(AxL.HostToChild.RESUME, (payload) => {
        console.log("init RESUME ");
        resolve();
      });
    });

    // await fetch(`./gallery/${this.customGallery || "list"}`)
    //   .then((data) => data.json())
    //   .then((json) => {
    //     this.NEW_DATA_FROM_OG = json;
    //   })
    //   .catch((error) => {
    //     console.warn(error);
    //   });

    await fetch(`./gallery/${this.customGallery || "list"}/0/30`)
      .then((data) => data.json())
      .then((json) => {
        this.NEW_DATA_FROM_OG = json;
      })
      .catch((error) => {
        console.warn(error);
      });

    const gameReady = this.axl.handshake().then((initialData) => {
      console.warn("handshake is done", initialData);
      this.game_id = initialData.puzzleId;
      // add deeplink access
      this.deepLink = initialData.deeplink; // assetID
      this.presetDifficulty = initialData.level; // beginer, intermediate, expert
      // to check if the game has to be
      this.signOrigin = initialData.signOrigin;
      // this.customGallery = initialData.gallery;
      /**
       *  direct access to an asset from the linkeditor
       *  this.direct_access = initialData.direct_access
       */

      let objJsonStr = JSON.stringify(initialData);
      let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
      console.log(objJsonB64);
      if (location.hostname === "localhost") this.init();
    });

    // Make sure game is initialized AND we got the first resume call
    Promise.all([gotFirstResume, gameReady]).then(() => {
      console.log("init PUZZLE");
      if (!this.puzzle) this.init();
      // No need for "if (!this.puzzle)" anymore because this can only happen once.
    });
  }

  async init() {
    console.log("init");
    this.galleryData = this.NEW_DATA_FROM_OG || (await this.getGalleryData());
    //console.log(this.galleryData);
    // DEFINE UID
    this.UID = "_" + Math.random().toString(36).substr(2, 9);
    console.log("GAME ID : ", this.UID);
    this.removeHandlers();
    //
    this.image = document.getElementById("puzzle-image");
    //
    this.zoomIn = document.getElementsByClassName("zoomIn")[0];
    //
    this.zoomOut = document.getElementsByClassName("zoomOut")[0];
    // SHOW ZOOM BUTTONS IF INLINE
    if (this.IS_INLINE) {
      this.zoomIn.style.display = "unset";
      this.zoomOut.style.display = "unset";
    }
    this.lastpinch = 0;
    //
    this.lightmode = document.getElementsByClassName("lightmode")[0];
    this.lmode = "light";
    //
    this.share_nav = document.getElementsByClassName("share_nav")[0];
    //
    this.help = document.getElementsByClassName("photo")[0];
    //
    this.home = document.getElementsByClassName("home")[0];
    //
    this.curationHandler = this.onCurate.bind(this);
    this.shareHandler = this.onshare.bind(this);
    //
    this.controllers = document.getElementsByClassName("controllers")[0];
    //
    this.appIsStarted = false;
    this.keyIsPressed = false;
    //
    this.allUsers = {};
    //
    this.initGameHandler = this.initGame.bind(this);
    this.resizeHandler = this.onResize.bind(this);
    window.addEventListener("resize", this.resizeHandler);

    //
    console.log("++", this.deepLink, this.presetDifficulty);
    const URL_PARAM = await this.getURLParam();
    console.log("URL_PARAM", URL_PARAM);
    if (URL_PARAM) {
      //if (this.dramaTimeout) clearTimeout(this.dramaTimeout);
      //if (this.drama) this.drama.stop();
      this.initGallery();
      this.initFB();
      this.initPaper();
      this.initHandlers();
    } else {
      this.initGallery();
    }

    // keyboard interaction
    if (!this.isMobile) {
      document.addEventListener("keydown", this.onkeydown.bind(this));
      document.addEventListener("keyup", this.onkeyup.bind(this));
      document.addEventListener("contextmenu", (event) =>
        event.preventDefault()
      );
      // ACTIVATE WHEEL IF NOT INLINE
      if (!this.IS_INLINE)
        document.addEventListener("wheel", this.onwheel.bind(this), {
          passive: false,
        });
    }
  }

  onkeydown(e) {
    if (this.puzzle && !this.keyIsPressed) {
      this.keyIsPressed = true;
      this.puzzle.onGroup();
      // --> ANALYTICS
      if (this.axl) {
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "keyboard",
          label: "group_piece / " + this.puzzle.activeGroup,
          value: 0,
          nonInteraction: false,
        });
      }
    }
  }

  onkeyup(e) {
    this.keyIsPressed = false;
  }

  onshare(e) {
    const join_message = this.translator
      ? this.translator.get("share")
      : "Join my Puzzle Party to piece together works of art 🧩 with #GoogleArtsandCulture";
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: join_message,
        image: e.target.parentNode.getAttribute("data-url"),
      });
      // --> ANALYTICS
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "share_game",
        label: "pop_up",
        value: 0, //this.game_id ? this.game_id : this.UID,
        nonInteraction: false,
      });
    } else {
      // MESSAGE DISPLAY AS DEBUG TOOL ON CILEX-PUZZLE.APPSPOT.COM
      // IT's NOT ACCESSIBLE ON STELLA, because of axl
      window.open(
        "mailto:enterAnEmail?subject=PUZZLE PARTY&body=" +
          join_message +
          " https://cilex-puzzle.appspot.com/?gid=" +
          this.UID
      );
    }
  }

  async initGame(e) {
    //Set the image for the piece
    const piece = document.getElementById("template");
    switch (this.presetDifficulty) {
      case "beginer":
        piece.src = "./images/empty_white_360.png";
        this.piece_size = 256;
        break;
      case "intermediate":
        piece.src = "./images/empty_white_180.png";
        this.piece_size = 128;
        break;
      case "expert":
        piece.src = "./images/empty_white.png";
        this.piece_size = 64;
        break;
    }
    //Load the ref image
    const url_to_load = e.target.getAttribute("data-url") + "=s1200";
    const asset_id = e.target.getAttribute("asset-id");
    this.puzzle_image = await this.loadImage(url_to_load);
    this.active_asset_id = asset_id;
    this.image = this.puzzle_image;

    //remove gallery
    const gallery = document.getElementById("wrapper_gallery");
    gallery.parentNode.removeChild(gallery);

    this.initFB();
    this.initPaper();
    this.initHandlers();

    // --> ANALYTICS
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "start_game",
        label: "master / " + this.UID,
        value: 0,
        nonInteraction: false,
      });
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "select_asset",
        label: asset_id,
        value: 0,
        nonInteraction: false,
      });
      this.CAN_RECORD_INTERACTION = true;
    }
  }

  setRemoteLoader() {
    console.log("remoteLoader");
    const wrapper = document.createElement("div");
    wrapper.className = "remoteLoader";
    const loader = document.createElement("div");
    // loader.className = 'loader';
    loader.className = "textLoader";
    loader.textContent = "preparing the puzzle ...";
    wrapper.appendChild(loader);
    document.body.appendChild(wrapper);
  }

  async getURLParam() {
    if (!this.axl) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.game_id = urlParams.get("gid");
      this.deepLink = urlParams.get("gdl");
      this.presetDifficulty = urlParams.get("level") || "intermediate";
      this.direct_img = urlParams.get("dimg");
      this.curation_tool = urlParams.get("curation");
      if (this.curation_tool) this.curation = [["asset_id", "image_url"]];

      if (this.direct_img) {
        /**
         *  DEPRECATED
         *  HIDDEN FEATURE
         *  ALLOW TO USE ANY IMAGE ON THE WEB AS PUZZLE IMAGE
         *  Ex URL : cilex-puzzle.appspot.com/?optout=true&gid=1234&dimg=URL_ON_THE_WEB
         *  IT'S USING A PROXY SERVICE TO HANDLE the crossdomain issue.
         */
        this.active_asset_id = "1234";
        this.image = await this.loadImage("./proxy/?url=" + this.direct_img);
        this.puzzle_image = this.image;
        document.getElementById("puzzle-image").src =
          "./proxy/?url=" + this.direct_img;
        // DEFAULT VALUE
        this.presetDifficulty = urlParams.get("level") || "intermediate";
        this.piece_size =
          this.presetDifficulty == "expert"
            ? 64
            : this.presetDifficulty == "beginer"
            ? 256
            : 128;
        const piece = document.getElementById("template");
        piece.src =
          "./images/empty_white" +
          (this.piece_size == 64
            ? ""
            : this.piece_size == 128
            ? "_180"
            : "_360") +
          ".png";
      }
    }
    // CHECK IF GAME_ID EXIST
    if (this.game_id && this.game_id != "1234") {
      // this.database = firebase.database();
      this.database = Firebase.DB;
      this.game_id = await this.verifyGame();
      if (this.axl && this.game_id) {
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "start_game",
          label: "remote / " + this.game_id,
          value: 0,
          nonInteraction: false,
        });
      }
    }

    if (this.deepLink) {
      this.active_asset_id = this.deepLink;
      const url = await this.getURLFromAssetID(this.deepLink);
      this.image = await this.loadImage(url);
      this.puzzle_image = this.image;
      document.getElementById("puzzle-image").src = url;
      this.piece_size =
        this.presetDifficulty == "expert"
          ? 64
          : this.presetDifficulty == "beginer"
          ? 256
          : 128;

      const piece = document.getElementById("template");
      piece.src =
        "./images/empty_white" +
        (this.piece_size == 64
          ? ""
          : this.piece_size == 128
          ? "_180"
          : "_360") +
        ".png";
      console.log("level", this.presetDifficulty, "size", this.piece_size);
      if (this.axl) {
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "start_game",
          label: "deep_link / " + this.UID,
          value: 0,
          nonInteraction: false,
        });
      }
    }

    console.log("--", this.game_id, this.deepLink);

    return this.game_id || this.deepLink;
  }

  async getURLFromAssetID(asset_id) {
    //check if asset_id exist in gallery
    //if not, call the simpleog API to get the url
    return new Promise(async (resolve, reject) => {
      if (!this.galleryData.hasOwnProperty(asset_id)) {
        const url = await this.getURLFromSimpleog(asset_id);
        resolve(url);
      }

      for (const asset of this.galleryData) {
        if (asset.id === asset_id) {
          resolve(asset.url.replace("http://", "https://") + "=s1200");
        }
      }

      resolve(null);
    });
  }

  getURLFromSimpleog(asset_id) {
    return fetch("./simpleog/" + asset_id)
      .then((response) => response.json())
      .then((json) => {
        console.log(json);
        /**
         * GOT all data about the image in case of the asset_id is not in the default gallery
         */
        this.unlisted_data = json[0];
        return json[0].url.replace("http://", "https://") + "=s1200";
      });
  }

  verifyGame() {
    return new Promise((resolve, reject) => {
      Firebase.listen("/GAMES/" + this.game_id, (snapshot) => {
        const game = snapshot.val();
        console.log("GAME VERIFICATION FOR", this.game_id, game);
        if (!game || !game.datas) {
          console.log("no datas");
          this.game_id = null;
          resolve(this.game_id);
        } else if (game.datas.win) {
          this.GAME_STATE = "win";
          resolve(this.game_id);
        } else {
          resolve(this.game_id);
        }
      });
      // this.database.ref("/GAMES/" + this.game_id).once("value", (snapshot) => {
      //   const game = snapshot.val();
      //   console.log("GAME VERIFICATION FOR", this.game_id, game);
      //   if (!game || !game.datas) {
      //     console.log("no datas");
      //     this.game_id = null;
      //     resolve(this.game_id);
      //   } else if (game.datas.win) {
      //     this.GAME_STATE = "win";
      //     resolve(this.game_id);
      //   } else {
      //     resolve(this.game_id);
      //   }
      // });
    });
  }

  recordYourSelfAsPlayer() {
    if (this.direct_img || this.deepLink) this.game_id = null;
    console.log("EXISTING GAME ?? : ", this.game_id);

    this.push(
      "/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/users",
      this.UID
    );
  }
  initFB() {
    if (this.direct_img || this.deepLink) this.game_id = null;
    // if (!this.database) this.database = firebase.database();
    if (!this.database) this.database = Firebase.DB;

    //delete all games HERE JUST IN CASE
    // this.send("/GAMES/", null);
    console.log("erase games");
    this.recordYourSelfAsPlayer();

    /**
     *  FIX NEW FIREBASE JUNE 18 2024
     */
    // NEW LISTENER
    Firebase.listen(
      "/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/users",
      (snapshot) => {
        const users = snapshot.val();
        if (users) {
          const allUsers = Object.keys(users);
          this.USER_AMOUNT = allUsers.length;

          let _player = this.translator
            ? " " + this.translator.get("player")
            : " player";
          _player =
            allUsers.length > 1
              ? " " + this.translator.get("players")
              : _player;

          document.getElementById("playerAmount").textContent =
            allUsers.length + _player;
          document.getElementById("playerIcon").textContent =
            allUsers.length > 1 ? "people" : "person";

          for (let key in allUsers) {
            if (allUsers.hasOwnProperty(key)) {
              if (!this.allUsers.hasOwnProperty(users[allUsers[key]])) {
                this.allUsers[users[allUsers[key]]] = allUsers[key];
                // IF I DECONNECT MYSELF, I REMOVE FROM FB
                if (this.UID == users[allUsers[key]]) {
                  this.USER_KEY = allUsers[key];
                  // CHANGE DISCONNECTION
                  // this.database
                  //   .ref(
                  //     "/GAMES/" +
                  //       (this.game_id ? this.game_id : this.UID) +
                  //       "/users/" +
                  //       allUsers[key]
                  //   )
                  //   .onDisconnect()
                  //   .set(null);
                  Firebase.disconnect(
                    "/GAMES/" +
                      (this.game_id ? this.game_id : this.UID) +
                      "/users/" +
                      allUsers[key]
                  );
                } else {
                  // ADD REGULAR LISTENER
                  this.addFBMouseListeners(users[allUsers[key]]);
                  this.addWinActionListeners(
                    this.game_id ? this.game_id : this.UID
                  );
                }
              }
            }
          }
        }
      }
    );

    // //LISTEN TO ALL NEW USER
    // this.database
    //   .ref("/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/users")
    //   .on("value", (snapshot) => {
    //     const users = snapshot.val();
    //     if (users) {
    //       const allUsers = Object.keys(users);
    //       this.USER_AMOUNT = allUsers.length;

    //       let _player = this.translator
    //         ? " " + this.translator.get("player")
    //         : " player";
    //       _player =
    //         allUsers.length > 1
    //           ? " " + this.translator.get("players")
    //           : _player;

    //       document.getElementById("playerAmount").textContent =
    //         allUsers.length + _player;
    //       document.getElementById("playerIcon").textContent =
    //         allUsers.length > 1 ? "people" : "person";

    //       for (let key in allUsers) {
    //         if (allUsers.hasOwnProperty(key)) {
    //           if (!this.allUsers.hasOwnProperty(users[allUsers[key]])) {
    //             this.allUsers[users[allUsers[key]]] = allUsers[key];
    //             // IF I DECONNECT MYSELF, I REMOVE FROM FB
    //             if (this.UID == users[allUsers[key]]) {
    //               this.USER_KEY = allUsers[key];
    //               this.database
    //                 .ref(
    //                   "/GAMES/" +
    //                     (this.game_id ? this.game_id : this.UID) +
    //                     "/users/" +
    //                     allUsers[key]
    //                 )
    //                 .onDisconnect()
    //                 .set(null);
    //               // REMOVE THE GAME
    //               // if (!this.game_id) {
    //               // 	this.database.ref('/GAMES/' + this.UID).onDisconnect().set(null);
    //               // }
    //             } else {
    //               // ADD REGULAR LISTENER
    //               this.addFBMouseListeners(users[allUsers[key]]);
    //               this.addWinActionListeners(
    //                 this.game_id ? this.game_id : this.UID
    //               );
    //             }
    //           }
    //         }
    //       }
    //     }
    //   });
  }
  addWinActionListeners(id) {
    // this.database.ref("/GAMES/" + id + "/datas/win").on("value", (snapshot) => {
    //   const value = snapshot.val();
    //   if (value) {
    //     console.log("WIN HAS BEEN TRIGGED");
    //     this.puzzle.activateMessagePopup();
    //   }
    // });

    Firebase.listen("/GAMES/" + id + "/datas/win", (snapshot) => {
      const value = snapshot.val();
      if (value) {
        console.log("WIN HAS BEEN TRIGGED");
        this.puzzle.activateMessagePopup();
      }
    });
  }

  addFBMouseListeners(id) {
    console.log(
      "Listen to ",
      "/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/mouses/" + id
    );

    Firebase.listen(
      "/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/mouses/" + id,
      (snapshot) => {
        if (this.appIsStarted) {
          const value = snapshot.val();
          if (value) {
            try {
              switch (value.state) {
                case "mousedown":
                  this.puzzle.remotePickTile(
                    value.tilename.toString(),
                    value.date,
                    value.initialPositions,
                    value.connectedTilesNames || []
                  );
                  break;
                case "mouseup":
                  this.puzzle.remoteReleaseTile(
                    value.tilename.toString(),
                    value.finalPositions,
                    value.connectedTilesNames || []
                  );
                  break;
                case "mousedrag":
                  const values = value.values;
                  this.puzzle.remoteDragTile(
                    JSON.parse(values.delta),
                    value.tilename.toString(),
                    JSON.parse(value.position)
                  );
                  break;
                case "mousemove":
                  break;
              }
            } catch (error) {
              console.log(error);
            }
          }
        } else {
          this.appIsStarted = true;
        }
      }
    );

    // //LISTEN TO ALL MOUSES CHANGES FOR THAT GAME
    // this.database
    //   .ref(
    //     "/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/mouses/" + id
    //   )
    //   .on("value", (snapshot) => {
    //     if (this.appIsStarted) {
    //       const value = snapshot.val();
    //       if (value) {
    //         try {
    //           switch (value.state) {
    //             case "mousedown":
    //               this.puzzle.remotePickTile(
    //                 value.tilename.toString(),
    //                 value.date,
    //                 value.initialPositions,
    //                 value.connectedTilesNames || []
    //               );
    //               break;
    //             case "mouseup":
    //               this.puzzle.remoteReleaseTile(
    //                 value.tilename.toString(),
    //                 value.finalPositions,
    //                 value.connectedTilesNames || []
    //               );
    //               break;
    //             case "mousedrag":
    //               const values = value.values;
    //               this.puzzle.remoteDragTile(
    //                 JSON.parse(values.delta),
    //                 value.tilename.toString(),
    //                 JSON.parse(value.position)
    //               );
    //               break;
    //             case "mousemove":
    //               break;
    //           }
    //         } catch (error) {
    //           console.log(error);
    //         }
    //       }
    //     } else {
    //       this.appIsStarted = true;
    //     }
    //   });
  }
  initPaper() {
    //  POPUP HANDLER
    if (this.gallery) {
      this.gallery.mainWrapper.classList.add("hide");
    } else {
      const mainWrapper = document.getElementById("gallery");
      mainWrapper.classList.add("hide");
      this.setRemoteLoader();
    }
    this.controllers.classList.add("show");
    this.modalCloseHandler = this.onModalClose.bind(this);
    this.artworkInfo = mdc.dialog.MDCDialog.attachTo(
      document.querySelector(".mdc-dialog.sharing")
    );

    const shareButton = document.querySelector(".shareButton");
    if (shareButton.classList.contains("hide"))
      shareButton.classList.remove("hide");
    if (!shareButton.classList.contains("transparent"))
      shareButton.classList.add("transparent");

    this.artworkInfo.open();
    console.log("ARTWORK INFOS", this.artworkInfo);
    this.createCanvas();
    this.paper = new paper.PaperScope();
    this.paper.setup(this.canvas);
    this.paper.view.currentScroll = new this.paper.Point(0, 0);
    ////////// this.paper.view.autoUpdate = false;

    this.tool = new this.paper.Tool();
    console.log("TOOLS", this.tool);

    this.scrollVector = new this.paper.Point(0, 0);
    this.scrollMargin = 32;

    this.imgWidth = this.image.width;
    this.imgHeight = this.image.height;

    const config = {
      activeGroup: false,
      zoomScaleOnDrag: 1.125,
      imgName: "puzzle-image",
      imgSrc: this.puzzle_image
        ? this.puzzle_image
        : document.getElementById("puzzle-image"),
      imgUrl: this.puzzle_image
        ? this.puzzle_image.src
        : document.getElementById("puzzle-image").src,
      tileWidth: this.piece_size,
      tilesPerRow: 10,
      tilesPerColumn: 8,
      imgWidth: this.imgWidth,
      imgHeight: this.imgHeight,
      shadowWidth: 120,
    };
    this.puzzle = new Puzzle(this, config);
    this.saveTip = new SavingTip();
    this.image.style.margin =
      "-" + this.imgHeight / 2 + "px 0 0 -" + this.imgWidth / 2 + "px";
    this.artworkInfo.listen("MDCDialog:closed", this.modalCloseHandler);
    this.paper.view.onFrame = () => {};
  }
  onModalClose() {
    console.log(
      "THIS IS CLOSED",
      this.USER_AMOUNT,
      this.USER_LIMIT,
      this.GAME_STATE
    );
    if (this.USER_AMOUNT >= this.USER_LIMIT || this.GAME_STATE == "win") {
      this.resetApp();
    } else {
      //--> show up help
      if (!this.isMobile && this.puzzle && this.puzzle.draggableModal)
        this.puzzle.draggableModal.open();
    }
  }
  initHandlers() {
    this.zoomInHandler = this.onzoomin.bind(this);
    this.zoomIn.addEventListener("click", this.zoomInHandler);
    this.zoomOutHandler = this.onzoomout.bind(this);
    this.zoomOut.addEventListener("click", this.zoomOutHandler);
    this.lightHandler = this.onlight.bind(this);
    this.lightmode.addEventListener("click", this.lightHandler);
    this.share_nav.addEventListener("click", this.shareHandler);
    this.homeHandler = this.onhome.bind(this);
    this.home.addEventListener("click", this.homeHandler);
    this.helpHandler = this.onhelp.bind(this);
    this.help.addEventListener("click", this.helpHandler);

    this.mouseDownHandler = this.onMouseDown.bind(this);
    this.tool.onMouseDown = this.mouseDownHandler;
    this.mouseUpHandler = this.onMouseUp.bind(this);
    this.tool.onMouseUp = this.mouseUpHandler;
    this.mouseDragHandler = this.onMouseDrag.bind(this);
    this.tool.onMouseDrag = this.mouseDragHandler;
    this.pinchHandler = this.onPinch.bind(this);
    // activate PINCH only if not INLINE
    if (!this.IS_INLINE) this.hammerTool.on("pinch", this.pinchHandler);
    if (!this.isTouchDevice()) this.toolTips = new Tooltips();
  }
  removeHandlers() {
    if (this.puzzle) this.puzzle.removeGroupNavigation();
    if (this.puzzle && this.puzzle.draggableModal)
      this.puzzle.draggableModal.delete();
    if (this.zoomIn)
      this.zoomIn.removeEventListener("click", this.zoomInHandler);
    if (this.zoomOut)
      this.zoomOut.removeEventListener("click", this.zoomOutHandler);
    if (this.lightmode)
      this.lightmode.removeEventListener("click", this.lightHandler);
    if (this.share_nav)
      this.share_nav.removeEventListener("click", this.shareHandler);
    if (this.help) this.help.removeEventListener("click", this.helpHandler);
    if (this.home) this.home.removeEventListener("click", this.homeHandler);
    if (this.hammerTool) this.hammerTool.off("pinch");
    // remove modal handler
    if (this.artworkInfo)
      this.artworkInfo.unlisten("MDCDialog:closed", this.modalCloseHandler);
  }

  getGalleryData() {
    /**
     *  URL TO BE UPDATED FOR ARTWORKS MODIFICATIONS OR TRANSLATION
     *  IF THE FILE EXIST IN THE STORAGE,WE CAN RELY TO this.LANG
     *  DEFAULT IS ENGLISH AS CREDIT ARE NOT TRANSLATED
     */

    // const url =
    //   "https://cilex-puzzle.appspot.com.storage.googleapis.com/selection2.json";

    let url = "";
    switch (this.customGallery) {
      case "nasa":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/NASA/selected_0_en.json";
        break;
      case "diwali":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/DIWALI/selected_0_en.json";
        break;
      case "christmas":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/CHRISTMAS/selected_0_en.json";
        break;
      case "hanukkah":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/HANUKKAH/selected_0_en.json";
        break;
      case "kwanzaa":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/KWANZAA/selected_0_en.json";
        break;
      case "mexico":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/MX/selected_0_en.json";
        break;
      case "palace":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/PALACE/selected_0_en.json";
        break;
      case "fantastic":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/FANTASTIC/selected_0_en.json";
        break;
      case "daVinci":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/DAVINCI/selected_0_en.json";
        break;
      case "holi":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/HOLI/selected_0_en.json";
        break;
      case "holi2":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/HOLI2/selected_0_en.json";
        break;
      case "easter":
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/EASTER/selected_0_en.json";
        break;
      default:
        url =
          "https://cilex-puzzle.appspot.com.storage.googleapis.com/selection2.json?clearcache=" +
          Math.random();
    }

    /**
     *
     * SPECIAL NASA : DETECT WHICH JSON HAS TO BE LOADED
     */
    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);
    // const nasa_page = urlParams.get("page");
    // console.log("nasa_page", nasa_page);
    // const url = !nasa_page
    //   ? "https://cilex-puzzle.appspot.com.storage.googleapis.com/NASA/selectionNASA_en.json"
    //   : "https://cilex-puzzle.appspot.com.storage.googleapis.com/NASA/datas/selectionNASA160k_" +
    //     nasa_page * 600 +
    //     "_en.json";
    return new Promise((resolve, reject) => {
      // fetch(
      //   "https://cilex-puzzle.appspot.com.storage.googleapis.com/selection2.json"
      // )
      fetch(url)
        .then((data) => data.json())
        .then((json) => {
          resolve(json);
        });
    });
  }

  initGallery() {
    if (!this.gallery) {
      console.log("create gallery");
      this.gallery = new Gallery(this);
      const linearProgress = new MDCLinearProgress(
        document.querySelector(".mdc-linear-progress")
      );
    } else {
      console.log("reload gallery");
      this.gallery.show();
    }

    // --> ANALYTICS
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "load_gallery",
        label: undefined,
        value: 0, //this.UID,
        nonInteraction: false,
      });
    }
  }

  onResize(e) {
    if (this.canvas) {
      this.canvas.width = window.innerWidth / 2;
      this.canvas.height = window.innerHeight / 2;
      this.canvas.style.width = window.innerWidth;
      this.canvas.style.height = window.innerHeight;
    }
    if (this.gallery) this.gallery.update();
  }

  remove(start, end) {
    this.splice(start, end);
    return this;
  }
  onzoomin(e) {
    this.puzzle.zoom(0.1);
  }
  onzoomout(e) {
    this.puzzle.zoom(-0.1);
  }
  onrefresh(e) {
    this.reload();
    // --> ANALYTICS
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "reload_game",
        label: "reload_button",
        value: 0, //this.game_id ? this.game_id : this.UI,
        nonInteraction: false,
      });
    }
  }

  onlight(e) {
    const nav = document.getElementById("groupNavigation");
    if (document.body.classList.contains("dark")) {
      document.body.classList.remove("dark");
      this.lmode = "light";
      // group
      nav.style.backgroundImage = 'url("./images/svg/separation.svg")';
    } else {
      document.body.classList.add("dark");
      this.lmode = "dark";
      //group
      nav.style.backgroundImage = 'url("./images/svg/separation_dark.svg")';
    }
    // --> ANALYTICS
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "change_ui_option",
        label: this.lmode,
        value: 1,
        nonInteraction: false,
      });
    }
  }

  onhome(e) {
    console.log("home");
    this.resetApp();
  }
  onhelp(e) {
    console.log("help");
    // Hide the initial buttons...
    const shareButton = document.querySelector(".shareButton");
    if (!shareButton.classList.contains("hide"))
      shareButton.classList.add("hide");
    if (shareButton.classList.contains("transparent"))
      shareButton.classList.remove("transparent");
    const soloButton = document.querySelector(".soloButton");
    if (!soloButton.classList.contains("hide"))
      soloButton.classList.add("hide");
    const okButton = document.querySelector(".okButton");
    if (okButton.classList.contains("hide")) okButton.classList.remove("hide");
    const restartButton = document.querySelector(".restartButton");
    if (!restartButton.classList.contains("hide"))
      restartButton.classList.add("hide");
    if (this.puzzle) {
      if (this.puzzle.draggableModal.modal.classList.contains("show")) {
        this.puzzle.draggableModal.close();
      } else {
        this.puzzle.draggableModal.open();
      }
    }
  }
  onMouseDown(event) {
    if (
      !this.pinchState &&
      !this.puzzle.isDragging &&
      (!event.event.touches || event.event.touches.length < 2)
    ) {
      const d = new Date().getTime();
      const tileData = this.puzzle.pickTile(event.point, event.delta, d);
      const tile = tileData[0];
      const connectedTilesNames = tileData[1];
      this.puzzle.isDragging = true;
      if (tile) {
        // prevent default to avoid scolling while moving a piece
        // using the native event, not the paperjs one that has been deactivated
        event.event.preventDefault();
        this.send(
          "/GAMES/" +
            (this.game_id ? this.game_id : this.UID) +
            "/mouses/" +
            this.UID,
          {
            state: "mousedown",
            tilename: tile.tilename,
            date: d,
            initialPositions: {
              position: { x: tile.position.x, y: tile.position.y },
              cellPosition: {
                x: tile.originalCellPosition.x,
                y: tile.originalCellPosition.y,
              },
            },
            connectedTilesNames: connectedTilesNames,
          }
        );
      }
    }
  }

  onMouseUp(event) {
    console.warn("MOUSE UP");
    if (
      !this.pinchState &&
      (!event.event.touches || event.event.touches.length < 2)
    ) {
      this.puzzle.isDragging = false;
      this.diff = null;
      this.releasePiece();
    }
  }

  releasePiece() {
    let tileData = this.puzzle.releaseTile();
    let tilename = tileData[0];
    let connectedTilesNames = tileData[1];
    if (tilename) {
      // get final position and cell coord
      const tile = this.puzzle.tiles[tilename];
      const newVal = tile.cellPosition.add(this.puzzle.cellPositionDiff);
      this.send(
        "/GAMES/" +
          (this.game_id ? this.game_id : this.UID) +
          "/mouses/" +
          this.UID,
        {
          state: "mouseup",
          tilename: tilename,
          finalPositions: {
            position: { x: tile.position.x, y: tile.position.y },
            cellPosition: { x: newVal.x, y: newVal.y },
          },
          connectedTilesNames: connectedTilesNames,
        }
      );
      //reset connectedTiles
      this.puzzle.connectedTilesNames = [];
      // send GAME state ...
      const cellPositions = [];
      for (let i = 0; i < this.puzzle.initialPositionIndexes.length; i++) {
        cellPositions.push(null);
      }
      for (let i = 0; i < this.puzzle.initialPositionIndexes.length; i++) {
        if (
          this.puzzle.tiles[this.puzzle.initialPositionIndexes[i]].cellPosition
        ) {
          cellPositions[this.puzzle.initialPositionIndexes[i]] = {
            x: this.puzzle.tiles[this.puzzle.initialPositionIndexes[i]]
              .cellPosition.x,
            y: this.puzzle.tiles[this.puzzle.initialPositionIndexes[i]]
              .cellPosition.y,
          };
        } else {
          cellPositions[this.puzzle.initialPositionIndexes[i]] = {
            x: this.puzzle.tiles[this.puzzle.initialPositionIndexes[i]]
              .originalCellPosition.x,
            y: this.puzzle.tiles[this.puzzle.initialPositionIndexes[i]]
              .originalCellPosition.y,
          };
        }
      }
      this.saveTip.show(0);
      this.send(
        "/GAMES/" +
          (this.game_id ? this.game_id : this.UID) +
          "/datas/cellpositions",
        JSON.stringify(cellPositions)
      );
      this.send(
        "/GAMES/" + (this.game_id ? this.game_id : this.UID) + "/datas/date",
        new Date().getTime() // new Date()
      );

      // --> ANALYTICS
      if (this.axl && this.CAN_RECORD_INTERACTION) {
        this.CAN_RECORD_INTERACTION = false;
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "piece_release",
          label: this.puzzle.activeGroup ? "group" : "free",
          value: 0,
          nonInteraction: false,
        });
      }
    }
  }

  onMouseDrag(event) {
    // authorize dragging with 1 finger or 2 finger if it's inline
    // or only 1 finger if we are not inline
    if (
      !this.pinchState &&
      (!event.event.touches ||
        (event.event.touches.length < 2 && !this.IS_INLINE) ||
        (event.event.touches.length <= 2 && this.IS_INLINE))
    ) {
      let tilename = this.puzzle.dragTile(event.delta, event);
      let pos = {};
      if (this.puzzle.selectionGroup) {
        pos = {
          x: this.puzzle.selectionGroup.position.x,
          y: this.puzzle.selectionGroup.position.y,
        };
      }
      if (tilename && !this.GRACEFUL) {
        // if (!this.runTest) {
        // 	const date = new Date();
        // 	if (!this.activeDate) {
        // 		this.activeDate = date.getTime();
        // 	}
        // 	if (date.getTime() - this.activeDate >= 1000) {
        // 		this.runTest = true;
        // 		console.log(this.reqCounter);
        // 	}
        // }
        if (this.AUTHORIZE_CALL && !this.puzzle.disableFirebaseupdate) {
          this.send(
            "/GAMES/" +
              (this.game_id ? this.game_id : this.UID) +
              "/mouses/" +
              this.UID,
            {
              state: "mousedrag",
              tilename: tilename,
              values: { delta: JSON.stringify(event.delta) },
              position: JSON.stringify(pos),
            }
          );
          this.AUTHORIZE_CALL = false;
          setTimeout(() => {
            this.AUTHORIZE_CALL = true;
          }, 35);
        }
      }
    }
  }

  onKeyUp(event) {
    switch (event.key) {
      case "z":
        this.puzzle.zoom(0.1);
        break;
      case "x":
        this.puzzle.zoom(-0.1);
        break;
    }
  }
  send(_type, _data = null) {
    // this.database.ref(_type).set(_data);
    Firebase.send(_type, _data);
    this.reqCounter++;
  }
  push(_type, _data = null) {
    // this.database.ref(_type).push(_data);
    Firebase.directPush(_type, _data);
  }
  async load(url, callback) {
    await fetch(url).then((data) => {
      callback(data);
    });
  }
  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.addEventListener("load", () => {
        resolve(img);
      });
      img.addEventListener("error", (err) => {
        reject(err);
      });
      img.src = url;
    });
  }
  resetApp() {
    Firebase.reset(
      "/GAMES/" +
        (this.game_id ? this.game_id : this.UID) +
        "/users/" +
        this.USER_KEY
    );
    // // remove the user
    // this.database
    //   .ref(
    //     "/GAMES/" +
    //       (this.game_id ? this.game_id : this.UID) +
    //       "/users/" +
    //       this.USER_KEY
    //   )
    //   .set(null);
    //remove  buttons
    const shareButton = document.querySelector(".shareButton");
    if (!shareButton.classList.contains("hide"))
      shareButton.classList.add("hide");
    if (shareButton.classList.contains("transparent"))
      shareButton.classList.remove("transparent");
    const soloButton = document.querySelector(".soloButton");
    if (!soloButton.classList.contains("hide"))
      soloButton.classList.add("hide");

    const restartButton = document.querySelector(".restartButton");
    if (!restartButton.classList.contains("hide"))
      restartButton.classList.add("hide");
    const okButton = document.querySelector(".okButton");
    if (!okButton.classList.contains("hide")) okButton.classList.add("hide");
    document.getElementById("my-dialog-title-sharing").textContent = this
      .translator
      ? this.translator.get("your_puzzle")
      : "Your puzzle";

    this.cleanTips();
    this.removeHandlers();
    if (this.paper.project) this.paper.project.activeLayer.removeChildren();
    this.paper.view.draw();
    this.paper.clear();
    this.paper.remove();
    this.paper = null;
    this.controllers.classList.remove("show");
    this.puzzle = null;
    if (this.artwork) this.artwork.reset();
    this.UID = this.game_id = "_" + Math.random().toString(36).substr(2, 9);
    console.log("GAME ID : ", this.UID);
    if (document.body.classList.contains("dark")) {
      document.body.classList.remove("dark");
    }
    if (document.body.classList.contains("game")) {
      document.body.classList.remove("game");
    }
    this.GAME_STATE = "ready";
    console.log("App reset, should create a gallery");
    // remove canvas --->
    document.body.removeChild(document.getElementById("canvas"));
    this.initGallery();
  }

  createCanvas() {
    // check if canvas already exists...
    if (document.getElementById("canvas")) {
      document.body.removeChild(document.getElementById("canvas"));
    }

    this.canvas = document.createElement("canvas");
    this.canvas.id = "canvas"; //document.getElementById('canvas');
    this.canvas.setAttribute("hidpi", "on");
    this.canvas.setAttribute("resize", "");

    this.setCursor(0);
    this.canvas.width = window.innerWidth / 2;
    this.canvas.height = window.innerHeight / 2;
    this.canvas.style.width = window.innerWidth;
    this.canvas.style.height = window.innerHeight;
    document.body.insertBefore(this.canvas, document.body.firstChild);
    const options = {
      preventDefault: true,
    };
    this.hammerTool = new Hammer(this.canvas, options);
    this.hammerTool.get("pinch").set({ enable: this.IS_INLINE ? false : true });

    // change canvas touch interaction if INLINE
    // otherwise native behaviour is not available because PAPERJS blocks it
    if (this.IS_INLINE)
      setTimeout(() => {
        this.canvas.style.touchAction = "pan-y";
      }, 100);
  }

  setCursor(val) {
    switch (val) {
      case 0:
        this.canvas.style.cursor = "move";
        break;
      case 1:
        this.canvas.style.cursor = "grab";
        break;
      default:
        this.canvas.style.cursor = "default";
    }
  }

  reload() {
    this.paper.project.activeLayer.removeChildren();
    this.paper.view.draw();
    this.puzzle.generateTiles();
  }
  removeFromArray(array, start, end) {
    array.splice(start, end);
    return array;
  }
  onwheel(e) {
    if (this.puzzle && e.target.id == "canvas") {
      e.preventDefault();
      this.puzzle.zoom(null, e);
    }
  }
  onPinch(e) {
    clearTimeout(this.pinchCheck);
    this.pinchState = true;
    if (this.puzzle) {
      //this.releasePiece();
      this.puzzle.zoom(null, {
        x: e.center.x,
        y: e.center.y,
        deltaY: e.scale - this.lastpinch < 0 ? 1 : -1,
      });
      /*-(e.scale - 1)*/
    }
    this.pinchCheck = setTimeout(() => {
      console.log("final");
      this.pinchState = false;
      this.puzzle.isDragging = false;
      this.lastpinch = 0;
      this.releasePiece();
    }, 200);
    this.lastpinch = e.scale;
  }

  /**
   * OPTIONAL HIDDEN FEATURE USED TO CURATE THE ASSETS
   * PUSH ALL SELECTED IN AN OBJECT TO BE DOWNLOADED WHEN FINISHED (by pressing ENTER)
   * @param {*} e
   */
  onCurate(e) {
    console.log(
      e.target.getAttribute("asset-id"),
      e.target.getAttribute("data-url")
    );
    this.curation.push([
      e.target.getAttribute("asset-id"),
      e.target.getAttribute("data-url"),
    ]);
    e.target.style.filter = "blur(10px)";
  }
  isTouchDevice() {
    const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
    const mq = function (query) {
      return window.matchMedia(query).matches;
    };
    if (
      "ontouchstart" in window ||
      (window.DocumentTouch && document instanceof DocumentTouch)
    ) {
      return true;
    }
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join(
      ""
    );
    return mq(query);
  }
  cleanTips() {
    const tips = Array.from(document.getElementsByClassName("tooltip"));
    const savetips = Array.from(document.getElementsByClassName("savetip"));

    for (const tip of tips) {
      document.body.removeChild(tip);
    }
    for (const savetip of savetips) {
      document.body.removeChild(savetip);
    }
  }
}

// window.onload = () => {
// 	new App();
// };
